<template>
	<div>
		<div style="text-align: center; font-size: 18px; color: #264EA7; margin-top: 30px;" v-if="dataList.length === 0">{{lang == 'en' ? 'No More' : '暂无数据'}}</div>
		<div class="pager-wrapper" ref="pager" v-if="dataList.length > 0">
			<div class="page-box" @click="toFirst">
				<i class="iconfont iconchevron_left_2"></i>
			</div>
			<div class="page-box" @click="toPrev">
				<i class="iconfont iconChevronLeft"></i>
			</div>
			<div class="page-box" v-for="item in pageTotal" :style="{backgroundColor: pageObj.current === item ? '#264EA7' : '#FFFFFF', color: pageObj.current === item ? '#FFFFFF' : '#264EA7'}" @click="toPage(item)">
				{{item}}
			</div>
			<div class="page-box" @click="toNext">
				<i class="iconfont iconChevronRight"></i>
			</div>
			<div class="page-box" @click="toLast">
				<i class="iconfont iconchevron_right_"></i>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'page',
		props: {
			pageObj: {
				type: Object
			},
			startSearch: {
				type: Boolean,
				default: true
			},
			clzl: {
				type: Number,
				default: 0
			}
		},
		data () {
			return {
				pageTotal: 1,
				dataList: []
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		created() {
			if(this.startSearch) {
				this.getData()
			}
			if(this.clzl > 0) {
				this.dataList = [1]
			}
		},
		methods: {
			getData() {
				let that = this
				var url = '/api/channel/findContentListByChannelId'
				if(that.pageObj.url) {
					url = that.pageObj.url
				}
				if(that.pageObj.start) {
					that.pageObj.start = that.$moment(that.pageObj.start).format("YYYY-MM-DD")
				}
				if(that.pageObj.end) {
					that.pageObj.end = that.$moment(that.pageObj.end).format("YYYY-MM-DD")
				}
				that.$http.post({
					url: url,
					data: that.pageObj
				}).then(res => {
					if(res.code === 'S200') {
						console.log(res.data.content);
						that.dataList = res.data.content
						that.pageTotal = res.data.pages
						that.$emit('getDataList', that.dataList, res.data.total)
					} else {
						that.$emit('getDataList', [])
					}
				})
			},
			toFirst() {
				let that = this
				if(that.pageObj.current === 1) {
					return
				}
				that.pageObj.current = 1
				that.getData()
			},
			toLast() {
				let that = this
				if(that.pageObj.current === that.pageTotal) {
					return
				}
				that.pageObj.current = that.pageTotal
				that.getData()
			},
			toPage(page) {
				let that = this
				if(page === that.pageObj.current) {
					return
				}
				that.pageObj.current = page
				that.getData()
			},
			toPrev() {
				let that = this
				if(that.pageObj.current === 1) {
					return
				}
				that.pageObj.current --
				that.getData()
			},
			toNext() {
				let that = this
				if(that.pageObj.current === that.pageTotal) {
					return
				}
				that.pageObj.current ++
				that.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.pager-wrapper {
		display: flex;
		justify-content: center;
		margin-top: 30px;
		.page-box {
			width: 18px;
			height: 18px;
			line-height: 16px;
			border: 1px solid #264EA7;
			margin: 0 6px;
			color: #264EA7;
			font-size: 8px;
			cursor: pointer;
			i {
				font-size: 8px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Page.vue